var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4917 1.70471H6.50841C3.47508 1.70471 1.66675 3.51305 1.66675 6.54638V13.5214C1.66675 16.563 3.47508 18.3714 6.50841 18.3714H13.4834C16.5167 18.3714 18.3251 16.563 18.3251 13.5297V6.54638C18.3334 3.51305 16.5251 1.70471 13.4917 1.70471ZM15.0001 10.663H10.6251V15.038C10.6251 15.3797 10.3417 15.663 10.0001 15.663C9.65841 15.663 9.37508 15.3797 9.37508 15.038V10.663H5.00008C4.65841 10.663 4.37508 10.3797 4.37508 10.038C4.37508 9.69638 4.65841 9.41305 5.00008 9.41305H9.37508V5.03805C9.37508 4.69638 9.65841 4.41305 10.0001 4.41305C10.3417 4.41305 10.6251 4.69638 10.6251 5.03805V9.41305H15.0001C15.3417 9.41305 15.6251 9.69638 15.6251 10.038C15.6251 10.3797 15.3417 10.663 15.0001 10.663Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.22e7a5b25ae24693f7f3eacbe163320d.svg";
export { ForwardRef as ReactComponent };